import React from "react";
import api from "../../Auth/Api";
import { Button, Typography, TextField, Box } from "@mui/material";
import { PageContainer, SectionHeader, FormDialog } from "../../Layout/Common";

// Vision & shared knowledge: the project's vision/goals/audience + the company-wide (Aurecas)
// vision/best-practices. The company text is a SINGLE SOURCE shared across all projects — editing
// it here changes it everywhere (confirmed before saving). Below: the lessons-learned memories
// (project + company) that agents append themselves via their permissions.
export default class VisionPage extends React.Component {
    state = {
        projectVision: "", companyVision: "",
        confirmCompanyOpen: false, savingProject: false,
        projectStatus: "active",
    };

    componentDidMount() { this.load(); this.loadStatus(); }
    load = () => {
        api.development("Loading vision", ["vision-get"], { silent: true })
            .then(r => { if (r) this.setState({ projectVision: r.projectVision || "", companyVision: r.companyVision || "" }); })
            .catch(() => {});
    };
    loadStatus = () => api.development("Loading status", ["project-status"], { silent: true })
        .then(r => { if (r && r.status) this.setState({ projectStatus: r.status }); }).catch(() => {});
    toggleStatus = () => {
        const next = this.state.projectStatus === "done" ? "active" : "done";
        api.development("Setting project status", ["set-project-status"], { payload: { status: next } })
            .then(() => this.loadStatus()).catch(() => {});
    };

    saveProject = () => api.development("Saving project vision", ["vision-set"], { payload: { scope: "project", content: this.state.projectVision } })
        .then(() => this.load()).catch(() => {});
    saveCompany = () => api.development("Saving company vision", ["vision-set"], { payload: { scope: "company", content: this.state.companyVision } })
        .then(() => { this.setState({ confirmCompanyOpen: false }); this.load(); }).catch(() => {});
    render() {
        const { projectVision, companyVision, confirmCompanyOpen } = this.state;
        const done = this.state.projectStatus === "done";
        return (
            <PageContainer maxWidth={1000}>
                <SectionHeader title="Vision">
                    <Button variant={done ? "contained" : "outlined"} color={done ? "success" : "warning"} onClick={this.toggleStatus}>
                        {done ? "Project DONE — Reactivate" : "Mark Project Done"}
                    </Button>
                </SectionHeader>
                <Typography variant="body2" sx={{ mb: 2, color: "text.secondary" }}>
                    Status: <strong>{this.state.projectStatus}</strong>. While done, agents suspend their scheduled check-ins
                    (no idle token burn); sending a new message or task from here reactivates the project automatically.
                </Typography>

                <Typography variant="h6" sx={{ mt: 1 }}>Project vision</Typography>
                <Typography variant="body2" sx={{ color: "text.secondary", mb: 1 }}>
                    Vision, goals, target audience and constraints for THIS project. Agents read this every work cycle.
                </Typography>
                <TextField fullWidth multiline minRows={6} value={projectVision}
                    onChange={e => this.setState({ projectVision: e.target.value })} />
                <Box sx={{ mt: 1, mb: 3 }}><Button variant="contained" onClick={this.saveProject}>Save Project Vision</Button></Box>

                <Typography variant="h6">Company vision (Aurecas)</Typography>
                <Typography variant="body2" sx={{ color: "text.secondary", mb: 1 }}>
                    Company-wide vision, design philosophy and best practices. Single source shared across ALL projects — saving here updates every project.
                </Typography>
                <TextField fullWidth multiline minRows={6} value={companyVision}
                    onChange={e => this.setState({ companyVision: e.target.value })} />
                <Box sx={{ mt: 1, mb: 3 }}><Button variant="contained" color="warning" onClick={() => this.setState({ confirmCompanyOpen: true })}>Save Company Vision</Button></Box>

                <Typography variant="body2" sx={{ color: "text.secondary" }}>Memories moved to the <strong>Memories</strong> page (Development → Memories).</Typography>

                <FormDialog open={confirmCompanyOpen} title="Save company-wide vision?" onClose={() => this.setState({ confirmCompanyOpen: false })}
                    onConfirm={this.saveCompany} confirmText="Save for ALL projects">
                    <Typography variant="body2">
                        The company vision is shared across <strong>all projects</strong> (single source). Saving here immediately changes what every agent on every project reads. Continue?
                    </Typography>
                </FormDialog>
            </PageContainer>
        );
    }
}
